import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  padding: 16px ${20 - 1}px;

  & + & {
    border-top: 1px solid ${Colors.GS300};
  }
`
